<template>
  <div class="ticket-table-card">
    <div class="table-title">{{$t('equipmentMoveIn.text.deviceList')}}</div>
    <el-table :data="ticketInfoTable"
    :title="$t('equipmentMoveIn.text.deviceList')"
              style="width: 100%"
              max-height="300">
     <el-table-column width="50"
                               :label="this.$t('alarmHistory.index')">
                <template slot-scope="scope">
                  <span>{{scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="snNo"
                               :label="$t('equipment.snNumber')">
              <template slot-scope="scope">
                <span>{{scope.row.snNo | maybeEmpty}}</span>
              </template>
              </el-table-column>
              <el-table-column prop="deviceType"
                               :label="$t('equipment.equipmentType')">
              <template slot-scope="scope">
                <span>{{scope.row.deviceType | maybeEmpty}}</span>
              </template>
              </el-table-column>
              <el-table-column prop="uNum"
                               :label="$t('equipment.uNo')">
              <template slot-scope="scope">
                <span>{{scope.row.uNum | maybeEmpty}}</span>
              </template>
              </el-table-column>
              <el-table-column prop="brand"
                               :label="$t('text.brand')"><template slot-scope="scope">
                <span>{{scope.row.brand | maybeEmpty}}</span>
              </template>
              </el-table-column>
              <el-table-column prop="model"
                               :label="$t('text.model')"><template slot-scope="scope">
                <span>{{scope.row.model | maybeEmpty}}</span>
              </template>
              </el-table-column>
              <el-table-column prop="assetBelong"
                               :label="$t('equipment.assetBelonging')"><template slot-scope="scope">
                <span>{{scope.row.assetBelong | maybeEmpty}}</span>
              </template>
              </el-table-column>
              <el-table-column prop="cabinetNo"
                               :label="$t('cabinet.cabinetNumCode')"><template slot-scope="scope">
                <span>{{scope.row.cabinetNo | maybeEmpty}}</span>
              </template>
              </el-table-column>
              <el-table-column prop="rackUIndex"
                               :label="$t('text.belongUbit')"><template slot-scope="scope">
                <span>{{scope.row.rackUIndex | maybeEmpty}}</span>
              </template>
              </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {
  cloneDeep
} from 'lodash';

export default {
  name: 'GeneralServicesTable',
  props: {
    // info
    ticketInfoTable: {
      type: Array,
      default () { return null; },
    },
    ticketTemplateCode: {
      type: String,
      default: ''
    },
  },
  computed: {
    ticketInfoTableCopy () {
      return cloneDeep(this.ticketInfo);
    }
  }
};
</script>
<style lang="scss" scoped>
.table-title {
  height: 40px;
  line-height: 40px;
  background-color: #f3f7fb;
  border: 1px solid #d9e1e9;
  font-size: 13px;
  border-bottom: none;
  padding-left: 8px;
}
.ticket-table-card {
  margin: 10px 0 20px 0;
}
a.auto-break {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/workSheet/common/GeneralServicesTable.vue